import 'bower/fancybox/source/jquery.fancybox';
import 'bower/fancybox/source/jquery.fancybox.css';
